import styled from 'styled-components'

export const Content = styled.div`
  display: grid;
  justify-items: center;
  padding-top: ${({ theme }) => theme.tokens.spacingUnit * 3}px;
  gap: ${({ theme }) => theme.tokens.spacingUnit * 2}px;
`

export const Title = styled.h1`
  font-size: 16px;
  margin: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.neutral.black700};
`

export const Description = styled.p`
  font-size: 12px;
  margin: 0;
  text-align: center;
  max-width: 28em;
  color: ${({ theme }) => theme.colors.neutral.black700};
`

export const Thumbnail = styled.img`
  display: block;
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.tokens.spacingUnit}px;
`

export const Actions = styled.div`
  display: grid;
  justify-items: center;
  width: 280px;
  gap: ${({ theme }) => theme.tokens.spacingUnit}px;
`
